// extracted by mini-css-extract-plugin
export default {"descriptionIconMenuTools":"DescriptionIconMenuTools_descriptionIconMenuTools__VYfgv"};